import Avatar from '@mui/material/Avatar';
import IconButton, { IconButtonProps } from '@mui/material/IconButton';
import { generateTestId } from '@vs/functions/generate-test-id';
import { useAccountInfo } from '@vs/hooks/hook-account-info';
import { useAvatarUrl } from '@vs/hooks/hook-use-avatar-url';
import { Env } from '@vs/utils/envConfig';
import { useTranslation } from 'react-i18next';

export type PropsUserAvatar = { env: Env } & Pick<IconButtonProps, 'onClick'>;

export default function UserAvatar({ env, onClick }: PropsUserAvatar) {
  const { t } = useTranslation('shared');
  const { data: accountInfo } = useAccountInfo();
  const accountAvatarUrl = useAvatarUrl({
    size: { width: 150, height: 150 },
    assetsOrigin: env.assets.vs,
  });
  const userName =
    `${accountInfo?.given_name ?? ''} ${accountInfo?.family_name ?? ''}`.trim();

  return (
    <IconButton
      {...generateTestId('btn-like', ['avatar-logo'])}
      className="p-0"
      onClick={onClick}
      aria-label={t('aria_label.account_avatar_menu')}
    >
      <Avatar
        sx={{ width: 38, height: 38 }}
        alt={userName}
        src={accountAvatarUrl}
      />
    </IconButton>
  );
}
